import { Component, inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  loginButtonClicked,
  onInitLoginPage,
} from '../../../../auth/state/auth.actions';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  store = inject(Store);

  ngOnInit(): void {
    this.store.dispatch(onInitLoginPage());
  }

  protected loginButtonClick() {
    this.store.dispatch(loginButtonClicked());
  }
}
